





















import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class IconHouseUp extends Vue {
    @Prop({ type: Number, default: 32 }) readonly size!: number
}
